export enum ReceiverProfileType {
    BuyerDestination = 2,
    Procurement = 3,
    Sales = 4,
    SupplierWarehouse = 6,
    BuyerWarehouse = 7,
}
